<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { required } from "vuelidate/lib/validators";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

// Custom Components
import { kiosk_policy, multi_lang_options } from "@/helpers/global.variable";
import IotDeviceService from "@/helpers/APIService/iotDevice.service";
import UserService from "@/helpers/APIService/user.service";
import { authComputed, authMethods } from "@/state/helpers";
import PageHeader from "@/components/page-header";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

export default {
  page: {
    title: "Kiosk Setting",
  },
  components: {
    ckeditor: CKEditor.component,
    PageHeader,
    draggable,
    Multiselect,
  },
  data() {
    return {
      title: "Kiosk Setting",
      items: [
        {
          text: "Home",
          href: "/kiosk-machine-setting",
        },
        {
          text: "Kiosk Setting",
          active: true,
        },
      ],
      editor: ClassicEditor,
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      kioskCommunication: null,
      editable: true,
      isDragging: false,
      // kiosk policy
      kiosk: "",
      kiosk_policy,
      hotel_fields: {},
      isBtnLoading: false,
      refreshCodeLoading: false,

      kioskImages: [],
      kioskBgImage: null,
      kioskBgImageLoad: false,
      kioskFlashVideo: null,
      isFlashVideoUploading: false,
      kioskSelfFlashVideo: null,
      isSelfFlashVideoUploading: false,

      // Message related
      messageData: [],
      message: {
        message: "",
        is_display: true,
        messageTitle: "Add New Message",
        is_message_btn_loading: false,
        is_message_edit: false,
        submittedMessage: false,
        message_id: "",
      },

      // Receipt Template related
      receipt_template: "",
      isLoadingTemplate: false,

      checkin_step: {
        current_step: "home",
        last_step: "",
        reset_kiosk: false,
      },
      multiLangOptions: multi_lang_options,
      selectedMultiLang: [],
      isMultiLangBtnLoading: false,
      isKioskRefresh: true,
      isOnTab: "general",

      // Iot Device
      selectType: "",
      kioskType: "",
      kioskTypeData: [{ text: "Select Kiosk Type", value: "" }],
      scannerType: "",
      IDScannerData: [{ text: "Select ID Scanner", value: "" }],
      dispenseType: "",
      dispenserTypedata: [{ text: "Select Dispenser", value: "" }],
      encoderType: "",
      encoderTypedata: [{ text: "Select Encoder", value: "" }],
      recyclerType: "",
      recyclerTypedata: [{ text: "Select Recycler", value: "" }],
      indicatorType: "",
      indicatorTypedata: [{ text: "Select Indicator", value: "" }],
      usbType: "",
      usbHubTypedata: [{ text: "Select USB Hub", value: "" }],
      printerType: "",
      printerTypedata: [{ text: "Select Printer", value: "" }],
      serviceType: "",
      serviceTypedata: [{ text: "Select Service", value: "" }],
      selectOption: [],
      deviceData: "",
      currKioskType: "",
      selectedType: "",
      configLoading: false,
      finalSubData: {},
      // Receipt Template related
      print_receipt_template: {
        guest_registration_card: "",
        check_in_template: "",
        check_out_template: "",
        parking_receipt: "",
      },
      variableList: [
        "{{hotel_name}}",
        "{{hotel_email}}",
        "{{hotel_front_desk_number}}",
        "{{hotel_phone_number}}",
        "{{hotel_brand}}",
        "{{hotel_address}}",
        "{{hotel_city}}",
        "{{hotel_state}}",
        "{{hotel_country}}",
        "{{hotel_zip_code}}",
        "{{hotel_time_zone}}",
        "{{hotel_check_in_time}}",
        "{{hotel_check_out_time}}",
        "{{hotel_logo}}",
        "{{booking_reference_no}}",
        "{{booking_status}}",
        "{{booking_room_number}}",
        "{{booking_room_type}}",
        "{{booking_check_in_date}}",
        "{{booking_check_in_time}}",
        "{{booking_check_out_date}}",
        "{{booking_check_out_time}}",
        "{{booking_reservation_charge}}",
        "{{booking_other_charge}}",
        "{{booking_total_charge}}",
        "{{booking_security_deposit}}",
        "{{guest_email}}",
        "{{guest_mobile}}",
        "{{guest_first_name}}",
        "{{guest_last_name}}",
        "{{guest_gender}}",
        "{{guest_address_line_first}}",
        "{{guest_address_line_second}}",
        "{{guest_zip_code}}",
        "{{guest_city}}",
        "{{guest_state}}",
        "{{guest_country}}",
        "{{guest_selfie_image}}",
        "{{guest_doc_image}}",
      ],
    };
  },
  validations: {
    message: {
      message: { required },
    },
  },
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getKioskPolicy(this.$route.params.id);
    }
    this.getAllIotDeviceData();
  },
  methods: {
    ...authMethods,
    //Method is used to get kiosk policy
    async getKioskPolicy(id) {
      await UserService.getKioskPolicyDetails(id)
        .then((kiosk) => {
          this.kiosk = kiosk;
          this.kioskBgImage = kiosk.bg_image;
          this.kioskFlashVideo = kiosk.flash_video;
          this.kioskSelfFlashVideo = kiosk.self_kiosk_flash_video;
          localStorage.setItem("roomName", kiosk.meet_id);
          localStorage.setItem("kiosk_id", kiosk.id);
          localStorage.setItem("roomToken", kiosk.meet_token);
          this.kioskImages = kiosk.kiosk_background_photo;
          this.messageData = kiosk.kiosk_important_message;
          setTimeout(() => {
            if (Object.keys(kiosk.print_receipt_template).length !== 0) {
              this.print_receipt_template = kiosk.print_receipt_template;
            }
          }, 500);
          Object.keys(kiosk.languages_supported).map((key) => {
            if (kiosk.languages_supported[key] == true) {
              this.selectedMultiLang.push({
                text: key,
                value: key,
              });
            }
          });
          if (Object.keys(kiosk?.iot_device_config?.kiosk_type).length !== 0) {
            this.kioskType = kiosk.iot_device_config.kiosk_type.id ?? "";
            this.currKioskType = kiosk.iot_device_config.kiosk_type.model;
          }
          if (
            Object.keys(kiosk?.iot_device_config?.cash_recycler).length !== 0
          ) {
            this.recyclerType = kiosk.iot_device_config.cash_recycler.id ?? "";
          }
          if (Object.keys(kiosk?.iot_device_config?.id_scanner).length !== 0) {
            this.scannerType = kiosk.iot_device_config.id_scanner.id ?? "";
          }
          if (
            Object.keys(kiosk?.iot_device_config?.indicator_light).length !== 0
          ) {
            this.indicatorType =
              kiosk.iot_device_config.indicator_light.id ?? "";
          }
          if (
            Object.keys(kiosk?.iot_device_config?.key_dispenser).length !== 0
          ) {
            this.dispenseType = kiosk.iot_device_config.key_dispenser.id ?? "";
          }
          if (Object.keys(kiosk?.iot_device_config?.key_encoder).length !== 0) {
            this.encoderType = kiosk.iot_device_config.key_encoder.id ?? "";
          }
          if (Object.keys(kiosk?.iot_device_config?.printer).length !== 0) {
            this.printerType = kiosk.iot_device_config.printer.id ?? "";
          }
          if (
            Object.keys(kiosk?.iot_device_config?.service_status).length !== 0
          ) {
            this.serviceType = kiosk.iot_device_config.service_status.id ?? "";
          }
          if (Object.keys(kiosk?.iot_device_config?.usb_hub).length !== 0) {
            this.usbType = kiosk.iot_device_config.usb_hub.id ?? "";
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to submit kiosk policy data
    submitKioskPolicy() {
      this.submitted = true;
      this.isBtnLoading = true;
      let kioskPolicyData = new FormData();
      if (this.kiosk.epp_type !== null) {
        kioskPolicyData.append("epp_type", this.kiosk.epp_type);
      }
      if (this.kiosk.epp_type !== null) {
        kioskPolicyData.append(
          "key_dispenser_url",
          this.kiosk.key_dispenser_url
        );
      }
      if (this.kiosk.epp_type !== null) {
        kioskPolicyData.append("key_encoder_url", this.kiosk.key_encoder_url);
      }
      UserService.updateKioskPolicyList(kioskPolicyData, this.kiosk.id)
        .then(() => {
          this.isBtnLoading = false;
          this.submitted = false;
          Middleware.notification("Successfully updated !!", "success");
          this.isKioskRefresh = false;
        })
        .catch((error) => {
          errorHandler(error);
          this.isBtnLoading = false;
          this.hasError = true;
          if (error.response.data.non_field_errors[0]) {
            this.errorMsg = error.response.data.non_field_errors[0];
          }
        });
    },
    // Method is use for maintained status changes
    changeStatus(data, type) {
      let kioskData = {};
      if (type == "main_page_buttons") {
        kioskData = {
          main_page_buttons: data.main_page_buttons,
        };
      } else if (type == "walk_in_features") {
        if (data.walk_in_features.id_scanning == false) {
          data.walk_in_features = {
            ...data.walk_in_features,
            id_text_ocr: data.walk_in_features.id_text_ocr ? 1 : 0,
            id_photo_verification_with_selfie: data.walk_in_features
              .id_photo_verification_with_selfie
              ? 1
              : 0,
          };
          kioskData = {
            walk_in_features: data.walk_in_features,
          };
        } else {
          kioskData = {
            walk_in_features: data.walk_in_features,
          };
        }
      } else if (type == "check_in_features") {
        if (data.check_in_features.id_scanning == false) {
          data.check_in_features = {
            ...data.check_in_features,
            id_text_ocr: 0,
            id_photo_verification_with_selfie: 0,
          };
          kioskData = {
            check_in_features: data.check_in_features,
          };
        } else {
          kioskData = {
            check_in_features: data.check_in_features,
          };
        }
      } else if (type == "check_out_features") {
        kioskData = {
          check_out_features: data.check_out_features,
        };
      } else if (type == "collect_key_features") {
        kioskData = {
          collect_key_features: data.collect_key_features,
        };
      } else if (type == "bg_slider") {
        kioskData = {
          bg_slider_status: data.bg_slider_status,
        };
      } else if (type == "is_out_of_service") {
        kioskData = {
          is_out_of_service: data.is_out_of_service,
        };
      } else if (type == "is_active") {
        kioskData = {
          is_active: data.is_active,
        };
      } else if (type == "is_language_support") {
        kioskData = {
          is_language_support: data.is_language_support,
        };
      } else if (type == "is_virtual_mode") {
        kioskData = {
          is_virtual_mode: data.is_virtual_mode,
        };
      } else {
        kioskData = {
          is_audio_prompt: data.is_audio_prompt,
        };
      }
      if (type !== "is_active") {
        this.isKioskRefresh = false;
      }
      UserService.updateKioskPolicyList(kioskData, data.id)
        .then(() => {
          this.isBtnLoading = false;
          this.submitted = false;
          Middleware.notification("Successfully updated !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
          this.isBtnLoading = false;
          this.hasError = true;
          if (error.response.data.non_field_errors[0]) {
            this.errorMsg = error.response.data.non_field_errors[0];
          }
        });
    },
    //Method kiosk policy
    copyCode(code) {
      Middleware.copyCode(code);
    },
    //Method is use for refresh kiosk login code
    async refreshCode(id) {
      this.refreshCodeLoading = true;
      await UserService.refreshKioskCode({ is_refresh_kiosk_code: true }, id)
        .then((response) => {
          this.kiosk = response;
          this.refreshCodeLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for upload new background image in kiosk add scroll bar
    uploadBgImages(id, event) {
      this.kioskBgImageLoad = true;
      this.kioskBgImage = null;
      const imageData = new FormData();
      imageData.append("bg_image", event.target.files[0]);
      UserService.updateKioskPolicyList(imageData, id)
        .then((response) => {
          this.isKioskRefresh = false;
          this.kioskBgImageLoad = false;
          this.kioskBgImage = response.bg_image;
          Middleware.notification("Successfully uploaded !!", "success");
        })
        .catch((error) => {
          this.kioskBgImage = null;
          errorHandler(error);
        });
    },
    // Method is use for upload new background video in kiosk add scroll bar
    uploadBgVideoImages(event) {
      this.isFlashVideoUploading = true;
      const imageData = new FormData();
      imageData.append("flash_video", event.target.files[0]);
      UserService.updateKioskPolicyList(imageData, this.kiosk.id)
        .then((response) => {
          this.isKioskRefresh = false;
          this.kioskFlashVideo = response.flash_video;
          Middleware.notification("Successfully uploaded !!", "success");

          this.isFlashVideoUploading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to upload video images
    uploadSelfVideoImages(event) {
      this.isSelfFlashVideoUploading = true;
      const imageData = new FormData();
      imageData.append("self_kiosk_flash_video", event.target.files[0]);
      UserService.updateKioskPolicyList(imageData, this.kiosk.id)
        .then((response) => {
          this.isKioskRefresh = false;
          this.kioskSelfFlashVideo = response.self_kiosk_flash_video;
          Middleware.notification("Successfully uploaded !!", "success");

          this.isSelfFlashVideoUploading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },

    // IMAGE RELATED

    // Method is use for upload new images in kiosk add scroll bar
    uploadImages(event) {
      const imageData = new FormData();
      imageData.append("image", event.target.files[0]);
      imageData.append("kiosk_user", this.kiosk.id);
      UserService.postKioskImages(this.kiosk.id, imageData)
        .then((response) => {
          this.isKioskRefresh = false;
          this.kioskImages.push(response);
          Middleware.notification("Successfully uploaded !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for delete images in kiosk
    deleteImage(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteKioskImages(image.kiosk_user, image.id)
            .then(() => {
              this.isKioskRefresh = false;
              this.kioskImages.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is use for change room image
    onChooseKioskImage: function (evt) {
      const imageData = new FormData();
      imageData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updateKioskImages(
        this.kiosk.id,
        evt.moved.element.id,
        imageData
      )
        .then(() => {
          Middleware.notification("Image positions changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // On click redirect to video setting page
    redirectToVideoSettingPage() {
      let routeData = this.$router.resolve({
        path: "/agent-console",
      });
      window.open(routeData.href, "_blank");
    },

    // MESSAGE RELATED

    // get kiosk messages
    async getKioskMessageList(id) {
      try {
        this.message.kiosk_id = id;
        const response = await UserService.getKioskMessages(id);
        this.messageData = response;
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for add new message modal
    openAddNewMessageModal() {
      this.$bvModal.show("message-modal");
    },
    // Method is use for handle ok of modal
    handleMessageOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleMessageSubmit();
    },
    // Method is use for add new message
    async handleMessageSubmit() {
      this.message.submittedMessage = true;
      this.message.is_message_btn_loading = true;
      this.$v.$touch();
      if (this.$v.message.$invalid) {
        this.message.is_message_btn_loading = false;
        return;
      } else {
        const messageData = {
          message: this.message.message,
          kiosk_user: this.kiosk.id,
        };
        if (this.message.is_message_edit) {
          try {
            const response = await UserService.updateKioskMessage(
              this.kiosk.id,
              this.message.message_id,
              messageData
            );
            this.messageData = this.messageData.map((message) => {
              if (message.id == response.id) {
                message = response;
              }
              return message;
            });
            this.isKioskRefresh = false;
            Middleware.notification("Successfully updated !!", "success");

            this.$bvModal.hide("message-modal");
            this.resetMessageModal();
          } catch (error) {
            this.message.is_message_btn_loading = false;
            errorHandler(error);
          }
        } else {
          try {
            const response = await UserService.postKioskMessage(
              this.kiosk.id,
              messageData
            );
            this.messageData.push(response);
            Middleware.notification("Successfully added !!", "success");
            this.$bvModal.hide("message-modal");
            this.resetMessageModal();
          } catch (error) {
            this.message.is_message_btn_loading = false;
            errorHandler(error);
          }
        }
      }
    },
    // Method is for cancel submit
    cancelMessageSubmit() {
      this.$bvModal.hide("message-modal");
      this.resetMessageModal();
    },
    // Method is use for edit message
    editMessage(data) {
      this.message = {
        message: data.message,
        messageTitle: "Edit Message",
        is_message_edit: true,
        message_id: data.id,
      };
      this.$bvModal.show("message-modal");
    },
    // Method is use for delete message
    deleteMessage(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            await UserService.deleteKioskMessage(this.kiosk.id, data.id);
            this.messageData = this.messageData.filter(
              (message) => message.id !== data.id
            );
            this.isKioskRefresh = false;
            Middleware.notification("Successfully deleted !!", "danger");
          } catch (error) {
            errorHandler(error);
          }
        }
      });
    },
    // Move messages
    onChooseKioskMessage: async function ($evt) {
      try {
        const response = await UserService.updateKioskMessage(
          $evt.moved.element.kiosk_user,
          $evt.moved.element.id,
          {
            priority_order: $evt.moved.newIndex + 1,
          }
        );
        this.isKioskRefresh = false;
        if (response !== undefined || null) {
          Middleware.notification("Message positions changed !!", "success");
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Message is use for change message
    changeMessageStatus(data) {
      UserService.updateKioskMessage(data.kiosk_user, data.id, {
        is_display: data.is_display,
      })
        .then(() => {
          this.isKioskRefresh = false;
          this.message.is_message_btn_loading = false;
          this.message.submittedMessage = false;
          Middleware.notification("Successfully updated !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
          this.message.is_message_btn_loading = false;
        });
    },
    // Method is use for reset modal
    resetMessageModal() {
      this.message.message = "";
      this.message.messageTitle = "Add New Message";
      this.message.is_message_btn_loading = false;
      this.message.is_message_edit = false;
      this.message.submittedMessage = false;
      this.message.message_id = "";
    },
    // Method is used to save multi language
    async submitKioskPolicyMultiLang(data) {
      this.isMultiLangBtnLoading = true;
      Object.keys(data.languages_supported).map((key) => {
        if (key !== "english") {
          if (
            this.selectedMultiLang.filter((item) => item.text == key).length !==
            0
          ) {
            data.languages_supported[key] = true;
          } else {
            data.languages_supported[key] = false;
          }
        }
      });
      const response = await UserService.updateKioskPolicyList(
        { languages_supported: data.languages_supported },
        data.id
      );
      if (response !== undefined || response !== null) {
        this.isMultiLangBtnLoading = false;
        Middleware.notification("Successfully updated !!", "success");
      }
      this.isKioskRefresh = false;
    },

    // RECEIPT RELATED

    // Update receipt template
    async updateReceipt(index) {
      this.isLoadingTemplate = true;
      try {
        const response = await UserService.updateKioskPolicyList(
          {
            print_receipt_template: this.print_receipt_template,
          },
          this.kiosk.id
        );
        this.isLoadingTemplate = false;
        if (response) {
          Middleware.notification("Successfully updated !!", "success");
        }
      } catch (error) {
        this.isLoadingTemplate = false;
        errorHandler(error);
      }
    },

    // IOT DEVICE RELATED

    // Method is used to get kiosk list
    getAllIotDeviceData() {
      IotDeviceService.getAllIotDeviceList()
        .then((response) => {
          this.selectOption = [];
          Object.keys(response).map((key) => {
            this.selectOption.push({
              selectedOPT: "",
              text: key.replaceAll("_", " "),
              value: key,
            });
          });
          let kioskOPT = [];
          response.kiosk_type.map((item) => {
            kioskOPT.push({ text: item.name, value: item.id, item: item });
          });
          let scannerOPT = [];
          response.id_scanner.map((item) => {
            scannerOPT.push({ text: item.name, value: item.id, item: item });
          });
          let dispenserOPT = [];
          response.key_dispenser.map((item) => {
            dispenserOPT.push({ text: item.name, value: item.id, item: item });
          });
          let encoderOPT = [];
          response.key_encoder.map((item) => {
            encoderOPT.push({ text: item.name, value: item.id, item: item });
          });
          let recyclerOPT = [];
          response.cash_recycler.map((item) => {
            recyclerOPT.push({ text: item.name, value: item.id, item: item });
          });
          let lightOPT = [];
          response.indicator_light.map((item) => {
            lightOPT.push({ text: item.name, value: item.id, item: item });
          });
          let usbOPT = [];
          response.usb_hub.map((item) => {
            usbOPT.push({ text: item.name, value: item.id, item: item });
          });
          let printOPT = [];
          response.printer.map((item) => {
            printOPT.push({ text: item.name, value: item.id, item: item });
          });
          let serviceOPT = [];
          response.service_status.map((item) => {
            serviceOPT.push({ text: item.name, value: item.id, item: item });
          });

          this.kioskTypeData = [
            { text: "Select Kiosk Type", value: "", item: {} },
            ...kioskOPT,
          ];
          this.IDScannerData = [
            { text: "Select ID Scanner", value: "", item: {} },
            ...scannerOPT,
          ];
          this.dispenserTypedata = [
            { text: "Select Dispenser", value: "", item: {} },
            ...dispenserOPT,
          ];
          this.encoderTypedata = [
            { text: "Select Encoder", value: "", item: {} },
            ...encoderOPT,
          ];
          this.recyclerTypedata = [
            { text: "Select Recycler", value: "", item: {} },
            ...recyclerOPT,
          ];
          this.indicatorTypedata = [
            { text: "Select Indicator", value: "", item: {} },
            ...lightOPT,
          ];
          this.usbHubTypedata = [
            { text: "Select USB Hub", value: "", item: {} },
            ...usbOPT,
          ];
          this.printerTypedata = [
            { text: "Select Printer", value: "", item: {} },
            ...printOPT,
          ];
          this.serviceTypedata = [
            { text: "Select Service", value: "", item: {} },
            ...serviceOPT,
          ];
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    selectData(type, data) {
      this.selectedType = type;

      let aList = [];
      if (type == "kiosk_type") {
        aList = this.kioskTypeData.filter((item) => {
          return item.value == data;
        });
      } else if (type == "id_scanner") {
        aList = this.IDScannerData.filter((item) => {
          return item.value == data;
        });
      } else if (type == "key_dispenser") {
        aList = this.dispenserTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "key_encoder") {
        aList = this.encoderTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "cash_recycler") {
        aList = this.recyclerTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "indicator_light") {
        aList = this.indicatorTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "usb_hub") {
        aList = this.usbHubTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "printer") {
        aList = this.printerTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "service_status") {
        aList = this.serviceTypedata.filter((item) => {
          return item.value == data;
        });
      } else if (type == "all") {
        aList = data;
      }

      let elseData = {};
      if (aList.length > 0 && type != "all") {
        elseData = aList[0].item;
      } else {
        elseData = aList;
      }

      let jsoner = JSON.stringify(elseData);

      // Replace all occurrences of '{{kiosk_model}}' with this.currKioskType
      let replacer = jsoner.replace(
        /{{kiosk_model}}/g,
        this.kiosk.kiosk_machine_number
      );

      // Convert the modified string back to a JSON object
      let modifier = {};
      modifier = JSON.parse(replacer);

      const textArea = document.getElementById("myTextarea");
      const jsonString = JSON.stringify(modifier, null, 2);

      let replato = jsonString.replace(
        /{{kiosk_model}}/g,
        this.kiosk.kiosk_machine_number
      );

      this.deviceData = replato;
      textArea.value = replato;
    },
    setKioskType(type, data) {
      let aList = [];
      if (type == "kiosk_type") {
        aList = this.kioskTypeData.filter((item) => {
          return item.value == data;
        });
      }

      if (aList.length > 0) {
        if (aList[0]?.item?.model) {
          this.currKioskType = aList[0].item?.model;
        }
      }
    },
    async saveData() {
      let newDevData = {};
      if (typeof this.deviceData === "string") {
        newDevData = JSON.parse(this.deviceData);
      } else {
        newDevData = this.deviceData;
      }
      if (this.selectedType == "kiosk_type") {
        this.kiosk.iot_device_config.kiosk_type = newDevData;
      } else if (this.selectedType == "id_scanner") {
        this.kiosk.iot_device_config.id_scanner = newDevData;
      } else if (this.selectedType == "key_dispenser") {
        this.kiosk.iot_device_config.key_dispenser = newDevData;
      } else if (this.selectedType == "key_encoder") {
        this.kiosk.iot_device_config.key_encoder = newDevData;
      } else if (this.selectedType == "cash_recycler") {
        this.kiosk.iot_device_config.cash_recycler = newDevData;
      } else if (this.selectedType == "indicator_light") {
        this.kiosk.iot_device_config.indicator_light = newDevData;
      } else if (this.selectedType == "usb_hub") {
        this.kiosk.iot_device_config.usb_hub = newDevData;
      } else if (this.selectedType == "printer") {
        this.kiosk.iot_device_config.printer = newDevData;
      } else if (this.selectedType == "service_status") {
        this.kiosk.iot_device_config.service_status = newDevData;
      } else if (this.selectedType == "all") {
        this.kiosk.iot_device_config = newDevData;
      }

      // let jsonString = JSON.stringify(this.kiosk.iot_device_config);

      // // Replace all occurrences of '{{kiosk_model}}' with this.currKioskType
      // let replacedString = jsonString.replace(
      //   /{{kiosk_model}}/g,
      //   this.currKioskType
      // );

      // // Convert the modified string back to a JSON object
      // let modifiedData = {};
      // modifiedData = JSON.parse(replacedString);

      // console.log(modifiedData);

      this.finalSubData = this.kiosk.iot_device_config;
      await this.submitConfig();
    },
    async submitConfig() {
      this.configLoading = true;
      await UserService.updateKioskPolicyList(
        {
          iot_device_config: this.finalSubData,
        },
        this.kiosk.id
      )
        .then((response) => {
          if (response) {
            this.configLoading = false;
            this.getKioskPolicy(this.$route.params.id);
            Middleware.notification(
              "Config updated successfully !!",
              "success"
            );
          }
        })
        .catch((error) => {
          this.configLoading = false;
          errorHandler(error);
        });
    },
    // METHOD IS USED TO REFRESH KIOSK
    socketTrigger() {
      this.checkin_step.reset_kiosk = true;
      this.checkin_step.last_step = "home";
      this.checkin_step.current_step = "home";
      this.kioskCommunication.send(
        JSON.stringify({
          command: "message",
          message: this.checkin_step,
        })
      );
      this.isKioskRefresh = true;
      Middleware.notification("Implementing new changes to kiosk...", "info");
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="page-title-right">
      <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
    </div>
    <div>
      <div class="card">
        <div class="card-body">
          <b-tabs
            justified
            nav-class="nav-tabs-custom"
            content-class="pt-3 text-muted"
          >
            <b-tab v-if="kiosk">
              <template v-slot:title>
                <template>
                  <div>
                    <h5 class="d-none d-sm-inline-block text-uppercase mb-0">
                      {{ kiosk.kiosk_machine_number }}
                    </h5>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <p class="mb-0 fst-italic text-primary">
                      (Active Code:
                      {{ kiosk.kiosk_login_code }}
                      <i
                        class="fas fa-clone text-primary ms-2"
                        id="code"
                        v-b-popover.hover.bottom="'copy code'"
                        @click="copyCode(kiosk.kiosk_login_code)"
                      />
                      )
                    </p>
                    <i
                      v-if="!refreshCodeLoading"
                      class="fas fa-redo text-primary ms-2"
                      v-b-popover.hover.bottom="'Re-generate code'"
                      @click="refreshCode(kiosk.id)"
                    />
                    <i
                      v-else
                      class="bx bx-revision bx-spin toggle-right text-primary ms-2 fs-4"
                    />
                  </div>
                </template>
              </template>
              <div role="tablist">
                <!-- kiosk general setting -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <h5 class="my-1">
                      <div class="row align-items-center">
                        <div
                          class="col-xxl-8 col-xl-7 col-md-6"
                          v-b-toggle.kisok-general-setting
                          @click="
                            () => {
                              isOnTab = 'general';
                            }
                          "
                        >
                          General Setting
                        </div>
                        <div class="col-xxl-4 col-xl-5 col-md-6">
                          <div
                            class="d-flex flex-wrap align-items-center justify-content-end"
                          >
                            <b-button
                              v-if="!kiosk.is_out_of_service"
                              class="float-end btn-sm me-2"
                              variant="outline-primary"
                              @click="redirectToVideoSettingPage()"
                            >
                              Join Call
                            </b-button>
                            <div
                              class="form-check form-switch d-flex align-items-center me-2 ms-1"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="virtual_mode"
                                v-b-popover.hover="'Virtual Mode'"
                                v-model="kiosk.is_virtual_mode"
                                @change="changeStatus(kiosk, 'is_virtual_mode')"
                              />
                              <label
                                for="virtual_mode"
                                class="form-check-label font-size-14 ms-2 lh-1 mb-0"
                              >
                                Virtual Mode
                              </label>
                            </div>
                            <div
                              class="form-check form-switch d-flex align-items-center"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="is_out_of_service"
                                v-b-popover.hover="'Out Of Service'"
                                v-model="kiosk.is_out_of_service"
                                @change="
                                  changeStatus(kiosk, 'is_out_of_service')
                                "
                              />
                              <label
                                for="is_out_of_service"
                                class="form-check-label font-size-14 ms-2 lh-1 mb-0"
                              >
                                Out Of Service
                              </label>
                            </div>
                            <b-button
                              v-if="!isKioskRefresh && isOnTab == 'general'"
                              class="float-end btn-sm ms-2"
                              variant="outline-primary"
                              @click="socketTrigger()"
                            >
                              Ref. Kiosk
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </h5>
                  </b-card-header>
                  <b-collapse
                    visible
                    id="kisok-general-setting"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="row align-items-center">
                          <div class="col-md-3">
                            <b-form-group
                              class="mb-4"
                              label="Collect Key"
                              label-for="collect_key"
                            >
                              <b-form-select
                                class="form-select"
                                id="epp_type"
                                type="text"
                                autocomplete="off"
                                v-model="kiosk.dispens_key_type"
                              >
                                <option value="automatic">Automatic</option>
                                <option value="manually">Manually</option>
                              </b-form-select>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group
                              class="mb-4"
                              label="Key Dispenser URL"
                              label-for="key_dispenser_url"
                            >
                              <b-form-input
                                id="key_dispenser_url"
                                v-model="kiosk.key_dispenser_url"
                                type="text"
                                autocomplete="off"
                              >
                              </b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group
                              class="mb-4"
                              label="Key Encoder URL"
                              label-for="key_encoder_url"
                            >
                              <b-form-input
                                id="key_encoder_url"
                                v-model="kiosk.key_encoder_url"
                                type="text"
                                autocomplete="off"
                              >
                              </b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col-md-1">
                            <b-button
                              class="float-end"
                              variant="outline-primary"
                              :class="{ disabled: isBtnLoading }"
                              @click="submitKioskPolicy()"
                            >
                              <i
                                v-if="isBtnLoading"
                                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                              />
                              Save
                            </b-button>
                          </div>
                          <p>Kiosk Setting</p>
                          <div class="d-flex flex-wrap">
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="audio-prompt"
                                  v-model="kiosk.is_audio_prompt"
                                  @change="
                                    changeStatus(kioskPolicy, 'audio_prompt')
                                  "
                                />
                                <label
                                  for="audio-prompt"
                                  class="form-check-label"
                                >
                                  Audio Prompt
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="background-slider"
                                  v-model="kiosk.bg_slider_status"
                                  @change="changeStatus(kiosk, 'bg_slider')"
                                />
                                <label
                                  for="background-slider"
                                  class="form-check-label"
                                  >Background Slider</label
                                >
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="is_language_support"
                                  v-model="kiosk.is_language_support"
                                  @change="
                                    changeStatus(kiosk, 'is_language_support')
                                  "
                                />
                                <label
                                  for="is_language_support"
                                  class="form-check-label"
                                >
                                  Multi Language Support
                                </label>
                              </div>
                            </div>
                          </div>
                          <p>Kiosk Main Page Menu</p>
                          <div class="d-flex flex-wrap">
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="check-in"
                                  v-model="kiosk.main_page_buttons.check_in"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label for="check-in" class="form-check-label">
                                  Check In
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="check-out"
                                  v-model="kiosk.main_page_buttons.check_out"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label for="check-out" class="form-check-label">
                                  Check Out
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="new-booking"
                                  v-model="kiosk.main_page_buttons.new_booking"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="new-booking"
                                  class="form-check-label"
                                >
                                  New Booking
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="pickup-key"
                                  v-model="kiosk.main_page_buttons.pickup_key"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="pickup-key"
                                  class="form-check-label"
                                >
                                  Pickup Key
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="hotel-info"
                                  v-model="kiosk.main_page_buttons.hotel_info"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="hotel-info"
                                  class="form-check-label"
                                >
                                  Hotel Info
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="nearby-place"
                                  v-model="
                                    kiosk.main_page_buttons.near_by_place
                                  "
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="nearby-place"
                                  class="form-check-label"
                                >
                                  Near By Place
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="floor-plan"
                                  v-model="kiosk.main_page_buttons.floor_plan"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="floor-plan"
                                  class="form-check-label"
                                >
                                  Floor Plan
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="feedback_or_review"
                                  v-model="
                                    kiosk.main_page_buttons.feedback_or_review
                                  "
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="feedback_or_review"
                                  class="form-check-label"
                                >
                                  Feedback Or Review
                                </label>
                              </div>
                            </div>
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="guest_club"
                                  v-model="kiosk.main_page_buttons.guest_club"
                                  @change="
                                    changeStatus(kiosk, 'main_page_buttons')
                                  "
                                />
                                <label
                                  for="guest_club"
                                  class="form-check-label"
                                >
                                  Guest Club
                                </label>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row align-items-center"
                            v-show="kiosk.is_language_support"
                          >
                            <p>Multi Language Support</p>
                            <div class="col-md-4">
                              <multiselect
                                v-model="selectedMultiLang"
                                track-by="value"
                                label="text"
                                placeholder="Select multi language"
                                :options="multiLangOptions"
                                :multiple="true"
                                :allow-empty="false"
                              >
                              </multiselect>
                            </div>
                            <div class="col-md-1">
                              <b-button
                                variant="outline-primary"
                                :class="{ disabled: isMultiLangBtnLoading }"
                                @click="submitKioskPolicyMultiLang(kiosk)"
                              >
                                <i
                                  v-if="isMultiLangBtnLoading"
                                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                />Save
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- Kiosk IOT Device Config -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <h5 class="my-1">
                      <div class="row align-items-center">
                        <div
                          class="col-xxl-8 col-xl-7 col-md-6"
                          v-b-toggle.iot-device-config-setting
                        >
                          IOT Device Config
                        </div>
                      </div>
                    </h5>
                  </b-card-header>
                  <b-collapse
                    visible
                    id="iot-device-config-setting"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="row">
                          <div
                            class="d-flex flex-wrap align-items-center justify-content-end"
                          >
                            <b-button
                              class="float-end my-1 mx-1"
                              variant="primary"
                              @click="
                                selectData('all', kiosk.iot_device_config)
                              "
                            >
                              View All
                            </b-button>

                            <b-button
                              class="float-end my-1 mx-1"
                              variant="success"
                              @click="saveData"
                              :class="{ disabled: configLoading }"
                            >
                              <i
                                v-if="configLoading"
                                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                              />
                              Save
                            </b-button>
                          </div>
                          <div class="col-md-6">
                            <!-- Kiosk Type -->
                            <div class="row align-items-end mb-4">
                              <div class="col-md-6">
                                <b-form-group
                                  label="Kiosk type"
                                  label-for="kiosk_type"
                                >
                                  <b-form-select
                                    class="form-select text-capitalize"
                                    id="kiosk_type"
                                    type="text"
                                    autocomplete="off"
                                    v-model="kioskType"
                                    :options="kioskTypeData"
                                    @change="
                                      setKioskType('kiosk_type', kioskType)
                                    "
                                  />
                                </b-form-group>
                              </div>
                              <div class="col-md-2">
                                <b-button
                                  v-if="kioskType != ''"
                                  variant="primary"
                                  @click="selectData('kiosk_type', kioskType)"
                                >
                                  View
                                </b-button>
                              </div>
                            </div>
                            <template v-if="kioskType != ''">
                              <!-- ID Scanner -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="ID Scanner"
                                    label-for="id_scanner"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="id_scanner"
                                      type="text"
                                      autocomplete="off"
                                      v-model="scannerType"
                                      :options="IDScannerData"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="
                                      selectData('id_scanner', scannerType)
                                    "
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- Key Dispenser -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Key Dispenser"
                                    label-for="key_dispenser"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="key_dispenser"
                                      type="text"
                                      autocomplete="off"
                                      v-model="dispenseType"
                                      :options="dispenserTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="
                                      selectData('key_dispenser', dispenseType)
                                    "
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- Key Encoder -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Key Encoder"
                                    label-for="key_encoder"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="key_encoder"
                                      type="text"
                                      autocomplete="off"
                                      v-model="encoderType"
                                      :options="encoderTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="
                                      selectData('key_encoder', encoderType)
                                    "
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- Cash Recycler -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Cash Recycler"
                                    label-for="cash_recycler"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="cash_recycler"
                                      type="text"
                                      autocomplete="off"
                                      v-model="recyclerType"
                                      :options="recyclerTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="
                                      selectData('cash_recycler', recyclerType)
                                    "
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- Indicator light -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Indicator Light"
                                    label-for="indicator_light"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="indicator_light"
                                      type="text"
                                      autocomplete="off"
                                      v-model="indicatorType"
                                      :options="indicatorTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="
                                      selectData(
                                        'indicator_light',
                                        indicatorType
                                      )
                                    "
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- USB hub -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="USB Hub"
                                    label-for="usb_hub"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="usb_hub"
                                      type="text"
                                      autocomplete="off"
                                      v-model="usbType"
                                      :options="usbHubTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="selectData('usb_hub', usbType)"
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- Printer -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Printer"
                                    label-for="printer"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="printer"
                                      type="text"
                                      autocomplete="off"
                                      v-model="printerType"
                                      :options="printerTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="selectData('printer', printerType)"
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                              <!-- Service status -->
                              <div class="row align-items-end mb-4">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Service Status"
                                    label-for="service_status"
                                  >
                                    <b-form-select
                                      class="form-select text-capitalize"
                                      id="service_status"
                                      type="text"
                                      autocomplete="off"
                                      v-model="serviceType"
                                      :options="serviceTypedata"
                                    />
                                  </b-form-group>
                                </div>
                                <div class="col-md-2">
                                  <b-button
                                    variant="primary"
                                    @click="
                                      selectData('service_status', serviceType)
                                    "
                                  >
                                    View
                                  </b-button>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="col-md-6">
                            <b-form-textarea
                              rows="35"
                              placeholder="Enter JSON"
                              autocomplete="off"
                              id="myTextarea"
                              spellcheck="false"
                              v-model="deviceData"
                            />
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- kiosk walk-in features -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-walkin-features
                        @click="
                          () => {
                            isOnTab = 'walk-in';
                          }
                        "
                      >
                        <h5 class="my-2">Walk-In Features</h5>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <b-button
                            v-if="!isKioskRefresh && isOnTab == 'walk-in'"
                            class="float-end btn-sm"
                            variant="outline-primary"
                            @click="socketTrigger()"
                          >
                            Ref. Kiosk
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-walkin-features"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="d-flex flex-wrap">
                          <div
                            v-for="(
                              walkin_feature, index
                            ) in kiosk.walk_in_features"
                            :key="index"
                          >
                            <div
                              class="w-240"
                              v-if="index == 'number_of_keys_allow'"
                            >
                              <div class="align-items-start mb-4">
                                <label for="number_of_keys_allow">
                                  Number of keys allow
                                </label>
                                <input
                                  class="form-control w-25"
                                  type="text"
                                  id="number_of_keys_allow"
                                  v-model="kiosk.walk_in_features[index]"
                                  @blur="
                                    changeStatus(kiosk, 'walk_in_features')
                                  "
                                />
                              </div>
                            </div>
                            <div class="w-240" v-else>
                              <div
                                class="form-check form-switch form-switch-md d-flex align-items-start mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :id="index + '_walin'"
                                  v-model="kiosk.walk_in_features[index]"
                                  @change="
                                    changeStatus(kiosk, 'walk_in_features')
                                  "
                                />
                                <label
                                  :for="index + '_walin'"
                                  class="form-check-label"
                                >
                                  {{ index.replaceAll("_", " ") }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- kiosk check-in features -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-checkin-features
                        @click="
                          () => {
                            isOnTab = 'checkin';
                          }
                        "
                      >
                        <h5 class="my-2">Check-In Features</h5>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <b-button
                            v-if="!isKioskRefresh && isOnTab == 'checkin'"
                            class="float-end btn-sm"
                            variant="outline-primary"
                            @click="socketTrigger()"
                          >
                            Ref. Kiosk
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-checkin-features"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="d-flex flex-wrap">
                          <div
                            v-for="(
                              checkin_feature, index
                            ) in kiosk.check_in_features"
                            :key="index"
                          >
                            <div
                              class="w-240"
                              v-if="index == 'number_of_keys_allow'"
                            >
                              <div class="align-items-start mb-4">
                                <label for="number_of_keys_allow">
                                  Number of keys allow
                                </label>
                                <input
                                  class="form-control w-25"
                                  type="text"
                                  id="number_of_keys_allow"
                                  v-model="kiosk.check_in_features[index]"
                                  @blur="
                                    changeStatus(kiosk, 'check_in_features')
                                  "
                                />
                              </div>
                            </div>
                            <div class="w-240" v-else :key="index">
                              <div
                                class="form-check form-switch form-switch-md d-flex align-items-start mb-4"
                              >
                                <input
                                  class="form-check-input kiosk-toggle"
                                  type="checkbox"
                                  :id="index + '_checkin'"
                                  v-model="kiosk.check_in_features[index]"
                                  @change="
                                    changeStatus(kiosk, 'check_in_features')
                                  "
                                />
                                <label
                                  :for="index + '_checkin'"
                                  class="form-check-label"
                                >
                                  {{ index.replaceAll("_", " ") }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- kiosk check-out features -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-checkout-features
                        @click="
                          () => {
                            isOnTab = 'checkout';
                          }
                        "
                      >
                        <h5 class="my-2">Check-Out Features</h5>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <b-button
                            v-if="!isKioskRefresh && isOnTab == 'checkout'"
                            class="float-end btn-sm"
                            variant="outline-primary"
                            @click="socketTrigger()"
                          >
                            Ref. Kiosk
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-checkout-features"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div>
                          <div class="d-flex flex-wrap">
                            <div
                              v-for="(
                                checkoutFeature, index
                              ) in kiosk.check_out_features"
                              :key="index"
                            >
                              <div class="w-240">
                                <div
                                  class="form-check form-switch form-switch-md d-flex align-items-start mb-4"
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="index + '_checkout'"
                                    v-model="kiosk.check_out_features[index]"
                                    @change="
                                      changeStatus(kiosk, 'check_out_features')
                                    "
                                  />
                                  <label
                                    :for="index + '_checkout'"
                                    class="form-check-label"
                                  >
                                    {{ index.replaceAll("_", " ") }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- kiosk collect key features -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-collect-key-features
                        @click="
                          () => {
                            isOnTab = 'collect-key';
                          }
                        "
                      >
                        <h5 class="my-2">Collect Key Features</h5>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <b-button
                            v-if="!isKioskRefresh && isOnTab == 'collect-key'"
                            class="float-end btn-sm"
                            variant="outline-primary"
                            @click="socketTrigger()"
                          >
                            Ref. Kiosk
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-collect-key-features"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="d-flex flex-wrap">
                          <div
                            v-for="(
                              collectkeyFeature, index
                            ) in kiosk.collect_key_features"
                            :key="index"
                          >
                            <div class="w-240">
                              <div
                                class="form-check form-switch form-switch-md d-flex align-items-start mb-4"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :id="index"
                                  v-model="kiosk.collect_key_features[index]"
                                  @change="
                                    changeStatus(kiosk, 'collect_key_features')
                                  "
                                />
                                <label :for="index" class="form-check-label">
                                  {{ index.replaceAll("_", " ") }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- kiosk image and video -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-image-video
                        @click="
                          () => {
                            isOnTab = 'video-image';
                          }
                        "
                      >
                        <h5 class="my-2">Image and Video</h5>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <b-button
                            v-if="!isKioskRefresh && isOnTab == 'video-image'"
                            class="float-end btn-sm"
                            variant="outline-primary"
                            @click="socketTrigger()"
                          >
                            Ref. Kiosk
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-image-video"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="row">
                          <div class="col-md-4">
                            <p>Kiosk Background Image</p>
                            <div class="input-group mb-2">
                              <input
                                type="file"
                                class="form-control"
                                id="kioskImages"
                                aria-describedby="inputGroupFileAddon04"
                                aria-label="Upload"
                                ref="file"
                                @change="uploadBgImages(kiosk.id, $event)"
                              />
                            </div>
                            <div
                              class="placeholder-glow"
                              v-if="kioskBgImageLoad"
                            >
                              <span
                                class="bg-data w-100 placeholder-lg placeholder"
                              >
                              </span>
                            </div>
                            <img
                              v-else
                              class="rounded bg-data object-fit w-100"
                              alt="kiosk_bg_image"
                              :src="
                                typeof kioskBgImage !== null || ''
                                  ? kioskBgImage
                                  : ''
                              "
                              id="kiosk_bg_image"
                              data-holder-rendered="true"
                            />
                          </div>
                          <div class="col-md-4">
                            <p>Kiosk Flash Video</p>
                            <div class="input-group mb-2">
                              <input
                                type="file"
                                class="form-control"
                                id="flash_video"
                                aria-describedby="inputGroupFileAddon04"
                                aria-label="Upload"
                                ref="file"
                                @change="uploadBgVideoImages($event)"
                              />
                            </div>
                            <div
                              class="placeholder-glow"
                              v-if="isFlashVideoUploading"
                            >
                              <span
                                class="bg-data w-100 placeholder-lg placeholder"
                              ></span>
                            </div>
                            <video
                              v-else
                              class="rounded bg-data object-fit w-100"
                              alt="kiosk_flash_video"
                              :src="
                                typeof kioskFlashVideo !== null || ''
                                  ? kioskFlashVideo
                                  : ''
                              "
                              id="kiosk_flash_video"
                              data-holder-rendered="true"
                              autoplay
                              loop
                              muted
                            />
                          </div>
                          <div class="col-md-4">
                            <p>Self Checkin Flash Video</p>
                            <div class="input-group mb-2">
                              <input
                                type="file"
                                class="form-control"
                                id="self_kiosk_flash_video"
                                aria-describedby="inputGroupFileAddon04"
                                aria-label="Upload"
                                ref="file"
                                @change="uploadSelfVideoImages($event)"
                              />
                            </div>
                            <div
                              class="placeholder-glow"
                              v-if="isSelfFlashVideoUploading"
                            >
                              <span
                                class="bg-data w-100 placeholder-lg placeholder"
                              ></span>
                            </div>
                            <video
                              v-else
                              class="rounded bg-data object-fit w-100"
                              alt="self_kiosk_flash_video"
                              :src="
                                typeof kioskSelfFlashVideo !== null || ''
                                  ? kioskSelfFlashVideo
                                  : ''
                              "
                              id="self_kiosk_flash_video"
                              data-holder-rendered="true"
                              autoplay
                              loop
                              muted
                            />
                          </div>
                        </div>
                        <hr />
                        <p>Kiosk Slider Images</p>
                        <div class="col-md-4 mb-2">
                          <div class="input-group">
                            <input
                              type="file"
                              class="form-control"
                              id="kioskImages"
                              aria-describedby="inputGroupFileAddon04"
                              aria-label="Upload"
                              ref="file"
                              @change="uploadImages($event)"
                            />
                          </div>
                        </div>
                        <!-- Image move section -->
                        <draggable
                          class="row"
                          v-model="kioskImages"
                          v-bind="dragOptions"
                          @change="onChooseKioskImage"
                        >
                          <div
                            class="col-md-2 mb-3"
                            v-for="(image, index) in kioskImages"
                            :key="index"
                          >
                            <div class="d-flex align-items-start cursor-move">
                              <img
                                class="rounded carousel-hotel-img object-fit"
                                alt="kiosk_ad_image"
                                :src="
                                  typeof image.image !== null || ''
                                    ? image.image
                                    : ''
                                "
                                :id="image.id"
                                data-holder-rendered="true"
                              />
                              <i
                                class="mdi mdi-trash-can fs-4 text-danger"
                                v-if="kioskImages.length !== 1"
                                slot="lable"
                                @click="deleteImage(image, index)"
                              />
                            </div>
                          </div>
                        </draggable>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- kiosk important messages -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-imp-message
                        @click="
                          () => {
                            isOnTab = 'imp-message';
                          }
                        "
                      >
                        <h5 class="my-2">Important Messages</h5>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <b-button
                            v-if="!isKioskRefresh && isOnTab == 'imp-message'"
                            class="float-end btn-sm"
                            variant="outline-primary"
                            @click="socketTrigger()"
                          >
                            Ref. Kiosk
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-imp-message"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <!-- Message move section -->
                        <draggable
                          class="row"
                          v-model="messageData"
                          v-bind="dragOptions"
                          @change="onChooseKioskMessage"
                        >
                          <div
                            class="col-md-4"
                            v-for="(message, index) in messageData"
                            :key="index"
                          >
                            <b-card header-class="bg-transparent">
                              <div
                                class="d-flex justify-content-between cursor-move"
                              >
                                <p class="fs-5 mb-0">{{ message.message }}</p>
                                <div>
                                  <div class="form-check form-switch">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      id="key-id-photo"
                                      v-model="message.is_display"
                                      @change="changeMessageStatus(message)"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="text-end">
                                <i
                                  class="fas fa-pencil-alt text-success mx-1 fs-5"
                                  slot="label"
                                  @click="editMessage(message)"
                                ></i>
                                <i
                                  class="mdi mdi-trash-can mx-1 fs-4 text-danger"
                                  slot="label"
                                  @click="deleteMessage(message)"
                                ></i>
                              </div>
                            </b-card>
                          </div>
                        </draggable>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="openAddNewMessageModal"
                        >
                          + Add Another Message
                        </button>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- Receipt Template -->
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <div class="row align-items-center">
                      <div
                        class="col-md-10"
                        v-b-toggle.kiosk-receipt
                        @click="
                          () => {
                            isOnTab = 'reciept-templates';
                          }
                        "
                      >
                        <h5 class="my-2">Receipt Templates</h5>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="kiosk-receipt"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div
                          v-for="(
                            template, key, index
                          ) in print_receipt_template"
                          :key="index"
                        >
                          <div class="row">
                            <div class="col-md-8">
                              <div>
                                <label :for="key" class="mt-3">
                                  <span slot="label" class="text-capitalize">
                                    {{ key.replaceAll("_", " ") }}
                                  </span>
                                </label>
                                <ckeditor
                                  :editor="editor"
                                  v-model="print_receipt_template[key]"
                                >
                                </ckeditor>
                                <b-button
                                  class="m-2"
                                  variant="primary"
                                  @click="updateReceipt(index)"
                                >
                                  <i
                                    v-if="isLoadingTemplate"
                                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                  />
                                  Save
                                </b-button>
                              </div>
                            </div>
                            <div class="col-md-4" id="temp">
                              <b-card>
                                <b-card-header>
                                  Template Variable
                                </b-card-header>
                                <b-card-body>
                                  <draggable v-model="variableList">
                                    <div
                                      v-for="(variable, index) in variableList"
                                      :key="index"
                                    >
                                      <p
                                        href="javascript:void(0)"
                                        class="dropdown-item dynamic_var cursor"
                                      >
                                        {{ variable }}
                                      </p>
                                    </div>
                                  </draggable>
                                </b-card-body>
                              </b-card>
                            </div>
                          </div>
                          <hr />
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- Modal is use for add and update imp messages -->
    <b-modal
      id="message-modal"
      centered
      :title="message.messageTitle"
      hide-footer
      title-class="font-18"
      @hidden="resetMessageModal"
    >
      <form ref="form" @submit.stop.prevent="handleMessageSubmit">
        <b-form-group label="Name" label-for="name-input" class="mb-3">
          <p slot="label" class="mb-2">
            Message <span class="text-danger">*</span>
          </p>
          <b-form-input
            id="name-input"
            v-model="message.message"
            placeholder="Add New Message"
            autocomplete="off"
            type="text"
            :class="{
              'is-invalid':
                message.submittedMessage && $v.message.message.$error,
            }"
          ></b-form-input>
          <div v-if="message.submittedMessage" class="invalid-feedback">
            <span v-if="!$v.message.message.required"
              >Message is required.</span
            >
          </div>
        </b-form-group>
        <div class="row">
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelMessageSubmit"
              >Cancel
            </b-button>
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              @click="handleMessageOk"
              :class="{ disabled: message.is_message_btn_loading }"
            >
              <i
                v-if="message.is_message_btn_loading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ message.is_message_edit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<style scoped>
.carousel-hotel-img {
  width: 250px;
  height: 180px;
}
.bg-data {
  height: 350px;
}
.w-240 {
  width: 240px;
}
.kiosk-toggle {
  min-width: 40px;
}
#temp .card-body {
  height: 600px;
  overflow-y: scroll;
}

#temp .card {
  max-height: 660px;
  margin-top: 30px;
}
</style>
